import React from 'react';

function Podcasts(props) {
    return (
        <div></div>
    );
}

export default Podcasts;